import { css } from '@design.estate/dees-element';

export const viewHostCss = css`
  :host {
    display: block;
    margin: auto;
    max-width: 1280px;
    padding: 16px 16px;
  }
`;